import TaggedLogger from '../debug/tagged-logger';

const sdk = require('branch-sdk');

let branchInstance;
/**
 * Branch.io SDK wrapper.
 */
class BranchIoSdk {
  /**
   * Inits branch io
   * @param {string} key - branch.io app_key
   * @return {Promise}
   */
  static getInstance(key) {
    return new Promise((resolve, reject) => {
      if (branchInstance) {
        resolve(branchInstance);
        return;
      }
      sdk.init(key, (err) => {
        if (err) {
          reject(err);
          return;
        }
        branchInstance = window.branch;
        resolve(branchInstance);
      });
    });
  }

  /**
   * Constructs
   * @param {string} key - branch.ios app_key
   */
  constructor(key) {
    this.logger = new TaggedLogger('BranchIoSdk', 'color: SeaGreen;');
    this.logger.info('Executing sdk instance promise');
    this.instancePromise = this.constructor.getInstance(key)
      .catch((err) => {
        this.logger.error('Instance failed to init.', err);
      });
  }

  /**
   * Executed the branch.io sdk method in a safe way.
   * @param method
   * @param args
   */
  execute(method, ...args) {
    this.instancePromise
        .then((branch) => {
          branch[method](...args);
        })
        .catch((err) => {
          this.logger.error(err);
        });
  }

  /**
   * Creates a link.
   * @link https://github.com/BranchMetrics/web-branch-deep-linking#linkdata-callback
   * @param {Object} data - data
   * @param {function} cb - callback
   */
  link(data, cb) {
    this.execute('link', data, cb);
  }
}

export default BranchIoSdk;



// WEBPACK FOOTER //
// ./Library/1.0/common/branch-io/BranchIoSdk.js